import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import Academy from "./components/Academy";
import Strategies from "./components/Strategies";
import CustomNavbar from "./components/CustomNavbar";
import VideoPlayer from "./components/VideoPlayer";
import ArticlePlayer from "./components/ArticlePlayer";
import SeeAllGrid from "./components/SeeAllGrid";
import SeeAllArticlesGrid from "./components/SeeAllArticlesGrid";
import SeeAllSecondGrid from "./components/SeeAllSecondGrid";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    // If there's a hash, remove it so that refreshing always goes to "/"
    if (window.location.hash) {
      window.history.replaceState({}, document.title, "/");
    }
  }, []);

  return (
    <div className="app-content">
      <CustomNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/academy" element={<Academy />} />
        <Route path="/strategies" element={<Strategies />} />
        <Route path="/watch/:videoId" element={<VideoPlayer />} />
        <Route path="/read/:videoId" element={<ArticlePlayer />} />
        <Route path="/academy/all" element={<SeeAllGrid />} />
        <Route path="/academy/articles" element={<SeeAllArticlesGrid />} />
        <Route path="/academy/second" element={<SeeAllSecondGrid />} />
      </Routes>
      <Footer />
    </div>
  );
}

function AppWithRouter() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWithRouter;
